import { gql } from '@apollo/client'

export const LocationFragment: any = gql`
  fragment LocationData on Location {
    id
    roi_id
    unique_id
    name
    slug
    brand_hub
    address_line1
    address_line2
    address_city
    address_county
    address_postcode
    telephone
    email
    report_data
    created_at
    updated_at
  }
`

const LinksFragment: any = gql`
  fragment LinksData on PaginatorLinks {
    totalResults
    totalPages
    page
    perPage
    prevPage
    nextPage
  }
`

export const GET_USERS_LOCATIONS: any = gql`
  query UsersLocations {
    usersLocations {
      id
      roi_id
      unique_id
      name
    }
  }
`

export const GET_LOCATIONS: any = gql`
  query GetLocations($input: QueryGetLocationsInput!) {
    getLocations(input: $input) {
      data {
        ...LocationData
      }
      links {
        ...LinksData
      }
    }
  }
  ${ LocationFragment }
  ${ LinksFragment }
`

export const GET_LOCATION_BY_ID: any = gql`
  query LocationById($input: QueryLocationByIdInput!) {
    locationById(input: $input) {
      ...LocationData
    }
  }
  ${ LocationFragment }
`

export const CREATE_LOCATION: any = gql`
  mutation CreateLocation($input: MutationCreateLocationInput!) {
    createLocation(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateLocationSuccess {
        data
      }
    }
  }
`

export const UPDATE_LOCATION: any = gql`
  mutation UpdateLocation($input: MutationUpdateLocationInput!) {
    updateLocation(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateLocationSuccess {
        data
      }
    }
  }
`

export const DELETE_LOCATION: any = gql`
  mutation DeleteLocation($input: MutationDeleteLocationInput!) {
    deleteLocation(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteLocationSuccess {
        data
      }
    }
  }
`
